import React from 'react';
import { css } from '@compiled/react';
import { Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Image from '@atlaskit/image';
import SectionLink from 'components/common/SectionLink';
import { UITrackEventPayload } from '@atlassian/community-library';
import { LinkData } from 'components/common/analytics-wrapped/LinkData';
import { MOBILE } from '../../utils/constants';

type GetStartedCardProps = {
  id: string;
  title: string;
  image: string;
  description: string;
  linkData: LinkData;
};

const GetStartedCard: React.FC<GetStartedCardProps> = ({
  id,
  title,
  image,
  description,
  linkData: { href, text: linkText, target },
}) => (
  <Box padding="space.200" css={boxStyling}>
    <div css={stackContainerStyle}>
      <div css={imageContainerStyle}>
        <Image src={image} alt={linkText} css={imageStyle} />
      </div>
      <span css={titleStyle}>{title}</span>
    </div>
    <p css={descriptionStyle}>{description}</p>
    <div css={sectionLinkContainerStyle}>
      <SectionLink
        href={href}
        text={linkText}
        {...(target ? { target } : {})}
        clickEventPayload={getLinkEventPayload('clicked', href, linkText, id)}
        hoverEventPayload={getLinkEventPayload('hovered', href, linkText, id)}
      />
    </div>
  </Box>
);

const getLinkEventPayload = (
  action: string,
  href: string,
  label: string,
  id: string,
): UITrackEventPayload => {
  return {
    action,
    actionSubject: 'link',
    actionSubjectId: 'communityHomeGetStartedCardLink',
    source: 'communityHomeGetStartedSection',
    attributes: {
      href,
      label,
      communityCardId: id,
    },
  } as UITrackEventPayload;
};

const titleStyle = css({
  fontFamily: 'Charlie Display, sans-serif',
  fontSize: '32px',
  fontWeight: 700,
  lineHeight: '40px',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '24px',
    lineHeight: '32px',
  },
});

const boxStyling = css({
  height: '376px',
});

const descriptionStyle = css({
  fontSize: '20px',
  fontFamily: 'Inter',
  color: token('color.text.subtle'),
  lineHeight: '32px',
  margin: '16px 0',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '16px',
    lineHeight: '24px',
    height: 'auto',
    marginLeft: '-14px'
  },
});

const stackContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '166px',
  '@media (max-width: 1279px)': {
    fontSize: '24px',
  },
      [MOBILE.MEDIA_QUERY]: {
      marginLeft: '-14px',
      marginTop: '-8px'
  },
  
});

const imageContainerStyle = css({
  width: '110px',
  height: '110px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

});

const imageStyle = css({
  maxHeight: '100%',
});

const sectionLinkContainerStyle = css({
  display: 'flex',
  alignItems: 'flex-end',
  height: '80px',
  '@media (max-width: 1279px)': {
    height: '48px',
  },
      [MOBILE.MEDIA_QUERY]: {
      marginLeft: '-14px'
  },
});

export default GetStartedCard;
